import { render } from "./AppBackButton.vue?vue&type=template&id=3e1b37d4"
import script from "./AppBackButton.vue?vue&type=script&lang=js"
export * from "./AppBackButton.vue?vue&type=script&lang=js"

import "./AppBackButton.vue?vue&type=style&index=0&id=3e1b37d4&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__